<template>
  <div class="app-detail">
    <!--BANNER-->
    <div v-if="vote.owner_name || vote.group_only == 1" class="no-permission">
      <img class="img" src="https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-21/7b8a3fb52af1fa55c1ba9a47d2f905c7.png" alt="">
      <div class='title-error'>无法参与</div>
      <div class='reason'>仅允许指定微信群成员，从群聊里点击小程序卡片打开。</div>
      <div class="assist-info">
        <div class="item">
          <span class="name">来源：</span>
          <span class="value">其他</span>
        </div>
        <div class="item">
          <span class="name">场景值：</span>
          <span class="value">其他</span>
        </div>
        <div class="item">
          <span class="name">昵称：</span>
          <span class="value">--</span>
        </div>
        <div class="item">
          <span class="name">群ID：</span>
          <span class="value">{{ vote.open_gid || '--' }}</span>
        </div>
        <div class="item">
          <span class="name">失败原因：</span>
          <span class="value">无shareTicket</span>
        </div>
      </div>
      <div class="buttons">
        <div @click="showVersionTip = true">返回首页</div>
        <div @click="showVersionTip = true">随便逛逛</div>
      </div>
      <div class="contact-customer" @click="contactCustomer">联系客服反馈</div>
    </div>
    <div v-else-if="notFound" class="error">
      <div class="error-text">投票不存在，可能已经被删除</div>
    </div>
    <div v-else>
      <template v-if="vote.type <= 1 && vote.group_only == 0">
        <div
          class="banner-header"
          v-if="vote['banner'] && vote['banner'].length > 0"
        >
          <van-swipe
            :autoplay="4000"
            class="swipe-content"
            :duration="1000"
            :show-indicators="true"
            indicator-color="white"
          >
            <van-swipe-item
              class="swipe-item"
              v-for="(item, i) in vote.banner"
              :key="i"
            >
              <van-image
                fit="cover"
                :src="item"
                @click="wxPreViewImg(item)"
                style="height:100%; width: 100%;"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!--上部内容-->
        <div class="vote-info">
          <div class="vote-info-title">{{ vote.title }}</div>
          <div class="tags">
            <!--<span>{{ vote.mode == 1 ? "多选" : "单选" }}</span>-->
            <span :class="[!vote.is_end ? 'tags-ing' : '']">{{vote.is_end ? "已结束" : "进行中"}}</span>
            <span>{{vote.daily == 1 ? "每人每天可投一次" : "每人仅可投一次"}}</span>
            <span v-if="vote.anonymous">匿名</span>
          </div>
          <div class="vote-more-item pr">
            <img src="../../assets/icon/ic_peoson.png" />
            <div class="vote-name">发起人：{{ vote.sign_name }}</div>
            <div class="owner-other-info">
              <img
                src="../../assets/icon/ic_detail_wechat.png"
                v-if="vote.wx_no"
                @click="isViewAddWx = true"
              />
              <img
                src="../../assets/icon/ic_detail_phone.png"
                v-if="vote.phone"
                @click="isViewCallPhone = true"
              />
            </div>
          </div>
          <div class="vote-more-item pr" v-if="vote.type == 2">
            <img src="../../assets/icon/end_time.png" />
            <div>开始时间：{{ vote.start_date }}</div>
          </div>
          <div class="vote-more-item pr">
            <img src="../../assets/icon/end_time.png" />
            <div>截止时间：{{ vote.end_date }}</div>
<!--            <span-->
<!--              class="no-end"-->
<!--              v-if="-->
<!--                vote.hide_result == 1 &&-->
<!--                  !vote.is_end &&-->
<!--                  !(vote.owner && vote.owner['is_requester'])-->
<!--              "-->
<!--              >截止后查看结果</span>-->
          </div>
          <div class="vote-more-item address-box pr" v-if="vote.address">
            <img src="../../assets/icon/ic_detail_location.png" />
            <div class="address" @click="openLocation">
              {{ vote.address }}
              <label class="address-tips"
                >{{ vote.range }}米范围内才能参与投票</label
              >
            </div>
          </div>

          <div class="vote-more-item pr">
            <img src="../../assets/icon/number.png" />
            <div>参与人数：{{ vote.total }}</div>
<!--            <span-->
<!--              class="vote-result btn-light"-->
<!--              v-if="-->
<!--                ((vote.owner && vote.owner.is_requester) ||-->
<!--                  (vote.hide_result == 0 && (vote.is_vote || vote.is_end)) ||-->
<!--                  (vote.hide_result == 1 && vote.is_end) ||-->
<!--                  vote.hide_result == 3) &&-->
<!--                  vote.options.length > 0-->
<!--              "-->
<!--              @click="toResult"-->
<!--              >查看投票结果</span>-->
          </div>
        </div>
        <!--下部内容-->
        <div class="vote-info-more">
          <div class="vote-info-content">
            <p>{{ vote.content }}</p>
            <span
              v-if="vote.hide_result != 2 && vote.limit != 0 && vote.mode == 1"
              >(说明：每人最少可选{{ vote.low_limit }}，最多可选{{
                vote.limit
              }}项)</span
            >
            <span
              v-else-if="
                vote.hide_result == 2 && vote.limit != 0 && vote.mode == 1
              "
              >(说明：该投票结果仅发起者可见，每人最少可选{{
                vote.low_limit
              }}，最多可选{{ vote.limit }}项)</span
            >
            <span v-else-if="vote.hide_result == 2"
              >(说明：该投票结果仅发起者可见)</span
            >
          </div>
          <div
            class="vote-info-remark"
            v-if="
              vote.options && vote.options.length && vote.options[0].image_url
            "
          >
            - 点击图片可查看详情 -
          </div>

          <div class="big-choose-box">
            <template
              v-if="vote.mode == 0 && vote.options && vote.options.length"
            >
              <van-radio-group
                class="vote-info-options"
                :class="[vote.type ? 'image' : 'text']"
                v-model="radio"
                v-for="(item, i) in vote.options"
                :key="i"
              >
                <div class="vote-info-options-item">
                  <div class="vote-info-options-item-pic">
                    <van-image
                      v-if="item.image_url"
                      width="4.27rem"
                      height="4.27rem"
                      fit="cover"
                      :src="item.shrink_img"
                      @click="wxPreViewImg(item.image_url)"
                    />
                  </div>
                  <div
                    v-if="
                      item.image_url &&
                        vote.group_only == 0 &&
                        vote.canvass == 1
                    "
                    class="to-canvass"
                    @click.stop="toCanvass(item.id)"
                  >
                    拉票
                  </div>
                  <div class="vote-info-options-item-check">
                    <van-radio
                      :name="item.id"
                      :disabled="
                        !!(
                          (vote.daily == 0 && (vote.is_vote || vote.is_end)) ||
                          (vote.daily && vote.today_vote)
                        )
                      "
                    >
                      <div class="radio-title">{{ item.text }}</div>
                    </van-radio>
                    <div class="vote-info-options-item-check-text">
                      <div
                        v-if="
                          (vote.owner && vote.owner.is_requester) ||
                            (vote.hide_result == 0 &&
                              (vote.is_vote || vote.is_end)) ||
                            (vote.hide_result == 1 && vote.is_end) ||
                            vote.hide_result == 3
                        "
                      >
                        <van-progress
                          :percentage="item.percent"
                          color="#00a8f3"
                          :show-pivot="false"
                          class="vote-progress"
                        />
                        <!-- <progress percent="{{item.percent}}" activeColor="#00a8f3" /> -->
                        <div class="percent">
                          {{ item.count }}票({{ item.percent }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-radio-group>
            </template>

            <template
              v-if="vote.mode == 1 && vote.options && vote.options.length"
            >
              <van-checkbox-group
                class="vote-info-options"
                :class="[vote.type ? 'image' : 'text']"
                v-model="checkChoose"
                v-for="(item, i) in vote.options"
                :key="i"
              >
                <div class="vote-info-options-item">
                  <div class="vote-info-options-item-pic">
                    <van-image
                      v-if="item.image_url"
                      width="4.27rem"
                      height="4.27rem"
                      fit="cover"
                      :src="item.shrink_img"
                      @click="wxPreViewImg(item.image_url)"
                    />
                  </div>
                  <div class="vote-info-options-item-check">
                    <van-checkbox
                      shape="square"
                      :name="item.id"
                      :disabled="
                        !!(
                          (vote.daily == 0 &&
                            (vote.is_vote || vote.is_end || item.disabled)) ||
                          (vote.daily == 1 &&
                            (vote.today_vote || item.disabled)) ||
                          (vote.limit != 0 &&
                            checkChoose.length == vote.limit &&
                            checkChoose.indexOf(item.id) == -1)
                        )
                      "
                    >
                      <div class="radio-title">{{ item.text }}</div>
                    </van-checkbox>
                    <div class="vote-info-options-item-check-text">
                      <div
                        v-if="
                          (vote.owner && vote.owner.is_requester) ||
                            (vote.hide_result == 0 &&
                              (vote.is_vote || vote.is_end)) ||
                            (vote.hide_result == 1 && vote.is_end) ||
                            vote.hide_result == 3
                        "
                      >
                        <van-progress
                          :percentage="item.percent"
                          color="#00a8f3"
                          :show-pivot="false"
                          class="vote-progress"
                        />
                        <!-- <progress percent="{{item.percent}}" activeColor="#00a8f3" /> -->
                        <div class="percent">
                          {{ item.count }}票({{ item.percent }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </template>

            <!--下部按钮内容-->
          </div>
          <div v-if="vote.showMoreBtn" class="btn-more" @click="authGateLaunch">查看更多选项</div>
<!--          <div v-else class="report-panel" @click="contactCustomer">-->
<!--            <span>举报</span>-->
<!--          </div>-->

<!--          <div class="share-panel">-->
<!--            <button @click="isViewShare = true">分享给好友</button>-->
<!--            <button v-if="vote.group_only" @click="isViewMinCode = true">-->
<!--              随便逛逛-->
<!--            </button>-->
<!--            <button v-else @click="isViewMinCode = true">生成分享图</button>-->
<!--            <button-->
<!--              v-if="vote.owner && vote.owner.is_requester"-->
<!--              @click="isViewMinCode = true"-->
<!--            >-->
<!--              复制投票-->
<!--            </button>-->
<!--            <button v-else @click="isViewMinCode = true">创建投票</button>-->
<!--          </div>-->
        </div>

        <!--底部按钮-->
        <section :class="footLimitWidth ? 'footbar-limit' : 'footbar'">
          <div :class="['owner-btn', vote.owner.is_requester ? 'god' : '']">
            <div class="bottom-btn" @click="showShareGuide">
              <i class="icon-share"></i>
              <div class="name">分享</div>
            </div>
            <div class="bottom-btn" @click="toResult">
              <i class="icon-rank"></i>
              <div class="name">查看票数</div>
            </div>
            <div class="bottom-btn" @click="isViewMinCode = true" v-if="vote.owner && vote.owner.is_requester">
              <i class="icon-manage"></i>
              <div class="name">管理</div>
            </div>
            <div class="bottom-btn" @click="isViewMinCode = true" v-else-if="vote.type != 3">
              <i class="icon-my"></i>
              <div class="name">我投的票</div>
            </div>
          </div>
          <div class="bottom-btn-right">
            <button class='button btn-enroll btn-disabled' @click="toSuccess" v-if="vote.is_end&&vote.is_start">投票已结束</button>
            <button class='button btn-enroll btn-disabled' @click="toSuccess" v-else-if="!vote.is_start">投票未开始</button>

            <!--非每日-->
            <button class='button btn-enroll' @click="comfirmVote" v-else-if="vote.daily==0 && vote.is_vote==0">{{vote.anonymous?'匿名':''}}投票</button>
            <button class='button btn-enroll btn-disabled' @click="toSuccess" v-else-if="vote.daily==0 && vote.is_vote==1">已完成投票</button>

            <!--每日-->
            <button class='button btn-enroll' @click="comfirmVote" v-else-if="vote.daily!=0 && vote.today_vote==0">{{vote.anonymous?'匿名':''}}投票</button>
            <button class='button btn-enroll btn-disabled' @click="toSuccess" v-else-if="vote.daily!=0 && vote.today_vote==1 && vote.today_end==0">今日已投票</button>
            <button class='button btn-enroll btn-disabled' @click="toSuccess" v-else-if="vote.daily!=0 && vote.today_vote==1 && vote.today_end==1">已完成投票</button>
          </div>
        </section>
        <!--去小程序引导-->
        <section class="gotoMinProgram" v-if="isViewMinCode">
          <div class="mask" @click="isViewMinCode = false"></div>
          <div class="minPanel">
            <div class="close-btn">
              <img
                @click="isViewMinCode = false"
                src="../../assets/icon/ic_popup_close.png"
              />
            </div>
            <div class="title">请去立吉投票小程序完成</div>
            <div class="content">
              网页版本暂不支持本功能，可以长按或扫码识别下图二维码，去小程序完成。
            </div>
            <div class="min-img-code">
              <img :src="minImg" />
            </div>
            <div class="tips">长按或扫码识别二维码，立即体验</div>
          </div>
        </section>
        <!--分享好友引导-->
        <section
          class="share-friend"
          v-if="isViewShare"
          @click="isViewShare = false"
        >
          <div class="arrow">
            <img src="../../assets/icon/ic_mask_arrow.png" />
          </div>
          <div class="share-desc">点击右上角“...”</div>
          <div class="share-desc">选择“发送给朋友”或者“分享到朋友圈”</div>
          <div class="share-desc">即可完成分享</div>
        </section>

        <!-- code dialog -->
        <div class="gotoMinProgram" v-if="codeDialog">
          <div class="mask" @click="codeDialog = false"></div>
          <div class="dialog-body code-dialog-body">
            <div class="code-header">为保证投票真实有效，请验证</div>
            <div class="code-body">
              <div>验证码：</div>
              <img class="code-img" :src="codeSrc" />
              <button class="refresh" @click="refreshCode">
                <img src="../../assets/icon/ic_refresh.png" />
              </button>
            </div>
            <input
              type="text"
              class="input-verify-code"
              placeholder="请输入验证码"
              placeholder-style="color:#ccc;"
              v-model="code"
            />
            <div class="code-tips" v-if="codeError">请输入正确的验证码</div>
            <div class="space" v-else></div>
            <div class="code-footer">
              <button class="btn-blue" @click="codeVote">提交</button>
              <button class="btn-white" @click="codeDialog = false">
                取消
              </button>
            </div>
          </div>
        </div>

        <!--打电话-->
        <section class="call-panel" v-if="isViewCallPhone">
          <div class="mask" @click="isViewCallPhone = false"></div>
          <div class="call-box">
            <div class="title">拨打电话</div>
            <div class="phone-num">{{ vote.phone }}</div>
            <div class="foot-btn">
              <div class="cancel" @click="isViewCallPhone = false">取消</div>
              <a
                :href="'tel:' + vote.phone"
                class="sure-btn"
                @click="isViewCallPhone = false"
                >确定</a
              >
            </div>
          </div>
        </section>

        <!--加微信-->
        <section class="add-wx-panel" v-if="isViewAddWx">
          <div class="mask" @click="isViewAddWx = false"></div>
          <div class="copy-wx-box">
            <div class="title">添加发起者微信</div>
            <img
              class="close-btn"
              @click="isViewAddWx = false"
              src="../../assets/icon/ic_popup_close.png"
            />
            <div class="creator-info">
              <div class="left-box">
                <img :src="vote.owner && vote.owner.upic" />
              </div>
              <div class="right-box">
                <div class="user-name">
                  {{ vote.owner && vote.owner.uname }}
                </div>
                <div class="wx-num">微信号：{{ vote.wx_no }}</div>
              </div>
            </div>
            <div
              class="copy-btn"
              v-clipboard:copy="vote.wx_no"
              v-clipboard:success="onCopy"
            >
              一键复制微信号
            </div>
          </div>
        </section>
      </template>
      <div style="text-align: center;" v-else>

        <div class="fail-page" v-if="vote.group_only == 1">
          <!-- 表情及标题 -->
          <div class="fail-header">
            <img class="emoji" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-06-30/8811753c1c9960ee9f7bb658fba38410.png" alt="">
            <h2 class="title">打开失败</h2>
          </div>
          <!-- 说明文本 -->
          <p class="desc">发起者「<span style="font-weight: bold;">{{vote.owner_name || vote.sign_name}}</span>」设置了此投票仅限指定群访问</p>
          <!-- 按钮区域 -->
          <div class="btn-group">
            <button @click="showVersionTip = true" class="btn position-r">
              回到首页
              <WxLink :wxPath="indexPath" />
            </button>
            <button  @click="showVersionTip = true"  class="btn position-r">
              随便逛逛
              <WxLink :wxPath="squarePath" />
            </button>
          </div>
          <!-- 解决步骤区域 -->
          <div class="solution">
            <p class="step-title">试试以下步骤解决</p>
            <ol class="step-list">
              <li>1. 确认群聊：请在发起者指定的群聊内打开。</li>
              <li>
                2. 重置小程序：尝试删除「立吉投票」小程序后，重新在指定群聊内点击投票链接打开。
              </li>
              <li>
                3. 以上都不行，<a
                  href="javascript:;"
                  class="contact-link"
                  @click="contactCustomer"
                  >联系客服</a
                >反馈。
              </li>
            </ol>
          </div>
          <!-- <div class="btn-group" style="margin-top: 50px;">
            <button class="btn position-r" @click="clearToken()">
              清空token
            </button>
            <button class="btn position-r" @click="clearToken('121212')">
              设置token失效
            </button>
          </div> -->
        </div>
        <img
          class="vote-bg-img"
          v-if="vote.group_only == 0 && share_bg"
          :src="share_bg"
          alt=""
        />
      </div>
    </div>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="minImg" />
    </van-popup>

    <AuthGate ref="authGate" />
  </div>
</template>

<script>
import {
  ImagePreview,
  RadioGroup,
  Radio,
  Swipe,
  SwipeItem,
  Progress,
  Checkbox,
  CheckboxGroup,
  Toast,
  Dialog
} from "vant";
import router from "@/router/index";
import http from "@/utils/request";
import api from "@/utils/api";
import {
  getToken,
  formatDateTime,
  getDistance,
  setShare
} from "@/utils/common";
import config from "@/utils/config";
import WxLink from "@/components/common/wxLink.vue";
import ImgDialog from "@/components/common/imgDialog.vue";
import AuthGate from "@/components/common/authGate.vue";
import {isWeixin, isMobile, reLogin} from "@/utils/common";
import resultMixin from '@/mixins/result';

export default {
  mixins: [resultMixin],
  data() {
    return {
      submitting: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      showVersionTip: false,
      settingSrc: '',
      indexPath: '/pages/index/index',
      squarePath: '/pages/square/square',
      vote: {}, //详情信息
      isViewMinCode: false,
      isViewShare: false,
      value: "111",
      radio: -1,
      options: [],
      checkChoose: [],
      defaultOptionImg: 'https://cdn-xcxcustom.weiyoubot.cn/material/2025-09-09/5cc406aafb877a38f002305aebd16426.jpg',
      minDetailImg: null, //小程序详情二维码
      gotoMinTitle: "", //引导去小程序title
      gotoMinContent: "", //引导去小程序文字描述
      minImg: "",
      codeDialog: false,
      codeSrc: "",
      codeError: false,
      code: "",
      isViewCallPhone: false,
      isViewAddWx: false,
      defaultBanner: require("../../assets/icon/default_banner.png"),
      notFound: false,
      footLimitWidth: false,
      share_bg: ""
    };
  },
  mounted() {
    this.vid = this.$route.query.vid;
    if (!getToken() && !config.TOKEN) {
      if (this.isWeixin) {
        reLogin()
        return;
      } else {
        if (!this.isMobile) {
          // this.authGateLaunch()
        }
      }
    }
    if (config.MyWidth > 750) this.footLimitWidth = true;
    this.initVoteData();
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Progress.name]: Progress,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    WxLink,
    AuthGate,
    ImgDialog
  },
  methods: {
    clearToken(data) {
      if(data) {
        localStorage.setItem("token", data);
      }else {
        localStorage.clear()
      }
    },
    contactCustomer() {
      _ZHINI({ action: 'showPanel' })
    },
    //初始化获取详情数据
    initVoteData() {
      let self = this;
      let param = {
        vid: this.vid,
        access_token: getToken() || config.TOKEN
      };
      http.get(api.lotto.getVoteDetail, param).then(res => {
        if (res.sta == 0) {
          var vote = res.data,
            checkChoose = [];
          // 微信外的移动环境只展示前4个
          if (!this.isWeixin && !getToken()) {
            vote.options = (vote.options || []).slice(0, 4);
            vote.showMoreBtn = true;
          }
          if (vote.type <= 1) {
            // 每天投一票，需要修改选中状态
            if (vote.daily == 1 && vote.today_vote == 0) {
              var len = vote.options.length;
              for (var i = 0; i < len; i++) {
                var item = vote.options[i];
                item.checked = 0;
              }
            }
            vote.options = vote.options || [];
            vote.options.forEach((item) => {
              if (item.checked == 1) {
                if (vote.mode == 0) {
                  self.radio = item.id
                } else {
                  checkChoose.push(item.id);
                }
              }
              if (vote.type && !item.image_url) {
                item.image_url = item.shrink_img = self.defaultOptionImg
              }
            })
            self.checkChoose = checkChoose;
            if (vote.owner_name) {
              // 显示无法查看投票,H5不支持群可见投票
              self.notGroup = true;
            }
            if(vote.end_date) {
              vote.end_date = formatDateTime(vote.end_date * 1000, 2);
            }
            if(vote.start_date) {
              vote.start_date = formatDateTime(vote.start_date * 1000, 2);
            }
          }
          if(!vote.hasOwnProperty('type')) {
            vote.group_only = 1;
          }
          vote.vid = vote.vid || self.vid
          self.vote = vote;
          self.setShareUrl();
          self.getMinProgram((vote.type <= 1 && vote.group_only == 0) || vote.group_only == 1 ? 1 : 0);
        } else if (res.sta == -1 && (res.msg == "data not found" || res.msg == 'invalid parameter')) {
          self.notFound = true;
        }
      });
    },
    //获取参与用户列表
    getUserInfos() {
      let _this = this;
      let parm = {
        lid: this.lid,
        access_token: getToken(),
        page: 1,
        count: 10,
        type: 1
      };
      http.get(api.lotto.getUserList, parm).then(res => {
        if (res.sta == 0) {
          _this.userInfo = res.data;
        }
      });
    },
    //获取详情页面的小程序二维码
    getMinProgram(type) {
      let _this = this;
      let parm = {
        vid: this.vid,
        type,
        access_token: getToken()
      };
      http.get(api.lotto.getShareImg, parm).then(res => {
        if (res.sta == 0) {
          if (type == 1) {
            _this.minImg = res.data.url;
          } else {
            _this.share_bg = res.data.url;
          }
        }
      });
    },
    setShareUrl() {
      let banner_url = this.vote.banner && this.vote.banner.length ? this.vote.banner[0] : this.defaultBanner;
      setShare(
        this.vote.title,
        "快来参加投票吧~",
        "http://m.huodongtou.cn/?vid=" + this.vid,
        banner_url
      );
    },
    onCopy() {
      this.isViewAddWx = false;
      Toast.success("复制成功");
    },
    onCopyTips() {
      MessageBox({
        title: "提示",
        message: "复制成功，请在微信里面添加好友",
        confirmButtonText: "我知道了"
      });
    },
    //投诉建议
    complaint() {
      this.minImg = this.minDetailImg;
      this.gotoMinTitle = "请去抽奖小程序完成";
      this.gotoMinContent =
        "网页版本暂不支持，可以长按或扫码识别下图二维码，去「我们爱抽奖」小程序操作。";
      this.isViewMinCode = true;
    },
    wxPreViewImg(imgUrl) {
     if (this.isWeixin) {
      window.wx.previewImage({
        current: imgUrl, // 当前显示图片的http链接
        urls: [imgUrl] // 需要预览的图片http链接列表
      });
     } else {
       ImagePreview({
         images: [imgUrl],
         showIndex: false,
         closeable: true
       })
     }
    },
    authGateLaunch() {
      return new Promise((resolve, reject) => {
        if (getToken()) {
          resolve()
        } else {
          this.$refs.authGate && this.$refs.authGate.launch({ vid: this.vid });
        }
      })
    },
    async showShareGuide() {
      if (this.isMobile) {
        await this.authGateLaunch()
      }
      this.isViewShare = true
    },
    toSuccess() {},
    async toCanvass(oid) {
       await this.authGateLaunch()
      router.push({
        path: "/canvass",
        query: { vid: this.vid, oid: oid }
      });
    },
    // async toResult() {
    //  if (!this.isWeixin) {
    //    await this.authGateLaunch()
    //  }
    //   router.push({
    //     path: "/result",
    //     query: { vid: this.vid, anonymous: this.vote.anonymous }
    //   });
    // },
    async comfirmVote() {
      if (!this.isWeixin) {
        await this.authGateLaunch()
      }

      let optionIds = [];
      this.code = "";
      if (this.vote.mode == 1) {
        // 多选
        optionIds = [...this.checkChoose];
        // 被选中的选项个数，小于规定的最小数量，需要弹框提示
        if (optionIds.length < this.vote.low_limit) {
          let limit = this.vote.low_limit;
          Dialog.alert({
            title: "提示",
            message: "请至少选择" + limit + "项"
          });
          return;
        }
      } else if (this.vote.mode == 0) {
        // 单选
        if (this.radio == -1) {
          Dialog.alert({
            title: "提示",
            message: "请至少选择一项"
          });
          return;
        }
        optionIds.push(this.radio);
      }
      this.optionIds = optionIds;
      // 验证码，地理位置。。
      if (this.vote.verify == 1) {
        this.codeDialog = true;
        this.getCode();
        return;
      }
      if (this.vote.address) {
        this.getLocation();
        return;
      }
      this.voteComfirm();
    },
    getCode() {
      var self = this;
      let param = {
        access_token: getToken(),
        vid: this.vid,
        option_ids: self.optionIds
      };
      http.post(api.lotto.getVerifyCode, param).then(res => {
        if (res.sta == 0) {
          self.codeSrc = res.data.code || "";
          self.codeDialog = true;
        }
      });
    },
    refreshCode() {
      this.getCode();
    },
    codeVote() {
      if (this.code.length != 4) {
        this.codeDialog = false;
        Dialog.alert({
          title: "提示",
          message: "请输入正确的验证码"
        });
        return;
      }
      if (this.vote.address) {
        this.codeDialog = false;
        this.getLocation();
        return;
      }
      this.voteComfirm();
    },
    voteComfirm(currentLongitude, currentLatitude) {
      var self = this;

      if (this.submitting) {
        return
      }
      this.submitting = true;

      let parm = {
        vid: self.vid,
        option_ids: self.optionIds,
        access_token: getToken(),
        form_id: "",
        notify: 0,
        code: self.code || ""
      };
      if (currentLongitude && currentLatitude) {
        parm.longitude = currentLongitude;
        parm.latitude = currentLatitude;
      }
      http.post(api.lotto.doVote, parm).then(res => {
        self.codeDialog = false;
        self.code = "";
        if (res.sta == 0) {
          router.push({
            path: "/success",
            query: { vid: self.vid }
          });
        } else {
          var code = res.errcode;
          var msg = res.msg;
          if (code == 600) {
            self.codeDialog = true;
            self.getCode(self);
            return;
          } else if (code == 100) {
            msg = "您已经投过票了~";
          }
          Dialog.alert({
            title: "提示",
            message: msg
          });
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    openLocation() {
      let latitude = this.vote.latitude;
      let longitude = this.vote.longitude;
      wx.openLocation({
        latitude: latitude,
        longitude: longitude
      });
    },
    getLocation() {
      var self = this;
      wx.getLocation({
        type: "gcj02",
        success: function(res) {
          var v = self.vote;
          var requireLongitude = v.longitude;
          var requireLatitude = v.latitude;
          var currentLongitude = res.longitude;
          var currentLatitude = res.latitude;
          var distance = getDistance(
            requireLongitude,
            requireLatitude,
            currentLongitude,
            currentLatitude
          );
          if (distance < v.range) {
            self.voteComfirm(currentLongitude, currentLatitude);
          } else {
            Dialog.alert({
              title: "提示",
              message:
                "您距离可投票地点还有" +
                Math.round(distance) +
                "米，因此无法投票"
            });
          }
        },
        fail(res) {
          Dialog.alert({
            title: "提示",
            message: "获取地理位置失败fail"
          });
        }
      });
    }
  }
};
</script>
<style>
.mint-msgbox-confirm {
  font-size: 16px !important;
}
</style>

<style scoped lang="scss">
@import "detail";
.van-checkbox {
  align-items: flex-start !important;
}

.share-friend {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  .arrow {
    width: 100%;
    margin-bottom: rem(100);
    text-align: end;
    img {
      margin-top: 5px;
      margin-right: rem(15);
      width: rem(58);
    }
  }
  .share-desc {
    text-align: center;
    font-size: rem(20);
    color: #22bbff;
    margin-top: rem(5);
  }
}

.gotoMinProgram {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 8433;
  top: 0;
  left: 0;
  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 8434;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .minPanel {
    position: absolute;
    z-index: 8435;
    width: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    padding: rem(20) rem(20);
    box-sizing: border-box;
    text-align: center;
    color: #333333;
    .close-btn {
      text-align: end;
      margin-top: rem(-5);
      width: 100%;

      img {
        width: rem(20);
        margin-right: rem(-8);
      }
    }
    .title {
      margin-top: rem(-10);
      font-size: rem(18);
    }
    .content {
      text-align: left;
      font-size: rem(13);
      margin-top: rem(15);
      line-height: 1.5;
    }
    .min-img-code {
      width: 100%;
      padding: rem(15) 0 rem(10);
      text-align: center;
      img {
        //width: 60%;
        width: rem(160);
        height: rem(160);
        margin: 0 auto;
        object-fit: cover;
        display: block;
      }
    }
    .tips {
      text-align: center;
      font-size: rem(12);
      color: #666666;
    }
  }
}

.call-panel {
  position: fixed;
  z-index: 9983;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 9984;
  }
  .call-box {
    position: absolute;
    z-index: 9985;
    background-color: #ffffff;
    width: 80%;
    left: 50%;
    top: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    .title {
      padding: rem(20) 0 rem(10);
      color: #333333;
      font-size: rem(18);
    }
    .phone-num {
      color: #999999;
      padding-bottom: rem(20);
      font-size: rem(15);
    }
    .foot-btn {
      border-top: 1px solid rgba(200, 200, 200, 0.4);
      display: flex;
      align-items: center;
      height: rem(45);
      line-height: rem(45);
      div {
        width: 50%;
        text-align: center;
        font-size: rem(18);
        color: #333;
      }
      .cancel {
        border-right: 1px solid rgba(200, 200, 200, 0.4);
      }
      .sure-btn {
        @extend div;
        color: #576b95;
      }
    }
  }
}
.vote-bg-img {
  width: 100%;
  max-width: 500px;
}
.fail-page {
  text-align: center;
  padding: 50px 25px 0;
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  color: #262626;
  .fail-header {
    margin-bottom: 20px;
  }
  .emoji {
    width: 45px;
    height: 45px;
    margin-bottom: 20px;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .desc {
    font-size: 16px;
    margin-bottom: 40px;
    padding: 0 15px;
  }
  .btn-group {
    margin-bottom: 40px;
    display: flex;
    align-content: center;
     .btn:first-child {
      margin-right: 15px
     }
  }
  .btn {
    padding: 8px 20px;
    background-color: #fff;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    cursor: pointer;
    flex: 1;
    font-size: 15px;
  }
  .solution {
    text-align: left;
    background: #F4F4F4;
    padding: 15px 15px 1px;
    font-size: 14px;
    color: #666666;
    border-radius: 4px;
  }
  .step-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .step-list {
    li{
      margin-bottom: 10px;
    }
  }
  .contact-link {
    color: #1890ff;
    text-decoration: none;
  }
  .contact-link:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/detailIndex.vue